import axios from "@/helpers/axios";
const commonURL = "/notice";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getNoticeList({}, payload) {
      try {
        const result = await axios.get(
          `${commonURL}/notices?page=${payload.page}&perPage=${
            payload.perPage
          }`,
          { headers: { bypass: true } }
        );
        if (!result.data.success) throw result.data;
        return result.data;
      } catch (e) {
        throw e;
      }
    },
    async getDetailNotice({}, payload) {
      try {
        const result = await axios.get(`${commonURL}/${payload}`, {
          headers: { bypass: true },
        });
        if (!result.data.success) throw result.data;
        return result.data;
      } catch (e) {
        throw e;
      }
    },
    async getOrderPopup({}) {
      try {
        const result = await axios.get(`${commonURL}/order-popups`);
        if (!result.data.success) throw result.data;
        return result.data;
      } catch (e) {
        throw e;
      }
    },
    async getMainPopup({}) {
      try {
        const result = await axios.get(`${commonURL}/main-popups`, {
          headers: { bypass: true },
        });
        if (!result.data.success) throw result.data;
        return result.data;
      } catch (e) {
        throw e;
      }
    },
  },
  getters: {},
};
